import { store } from 'src/app/store';
import { RTKQueryTag } from 'src/common/constants';
import { ApiResponse } from 'src/common/interfaces';
import { userSelfQueryTag } from 'src/common/slices';
import { apiSlice } from 'src/features/api/api-slice';
import {
  AnswerData,
  RoomAnswerResponseData,
} from 'src/features/room/components/question-and-answer-item/question-and-answer-item.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postAnswer: builder.mutation<ApiResponse<RoomAnswerResponseData>, AnswerData>({
      query: (body) => ({
        url: 'rooms/answer',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error) => {
        if (error || !result?.data?.isCorrect) {
          return [];
        }

        const tags = [
          userSelfQueryTag,
          { type: RTKQueryTag.Task },
          { type: RTKQueryTag.Scoreboard },
          { type: RTKQueryTag.DashboardQuestionsChart },
          { type: RTKQueryTag.DashboardNotifications },
          { type: RTKQueryTag.PathProgress },
          { type: RTKQueryTag.ModuleScoreboard },
          { type: RTKQueryTag.Module },
        ];

        if (result.data.isRoomCompleted) {
          tags.unshift({ type: RTKQueryTag.RunningInstances });
        }

        return tags;
      },
    }),
  }),
});

export const invalidateAnswerQuestion = () => {
  store.dispatch(
    extendedApiSlice.util.invalidateTags([
      userSelfQueryTag,
      { type: RTKQueryTag.Task },
      { type: RTKQueryTag.Scoreboard },
      { type: RTKQueryTag.ModuleScoreboard },
      { type: RTKQueryTag.Module },
    ]),
  );
};

export const { usePostAnswerMutation } = extendedApiSlice;
